import React, { memo, useRef, useEffect } from 'react'

/**
 * Компонент для вставки HTML с предотвращением лишних ререндеров.
 * Использует dangerouslySetInnerHTML, но обновляет DOM только при реальном
 * изменении HTML-строки, что предотвращает перезагрузку видео и других
 * медиа-элементов при скролле или ререндерах родительского компонента.
 */
const MemoizedHTML = memo(({ html, className, style }) => {
  const containerRef = useRef(null)
  const prevHtmlRef = useRef(html)

  useEffect(() => {
    if (containerRef.current && prevHtmlRef.current !== html) {
      containerRef.current.innerHTML = html
      prevHtmlRef.current = html
    }
  }, [html])

  // При первом рендере устанавливаем HTML через innerHTML в эффекте,
  // чтобы избежать моргания. Но для SSR/первого рендера используем
  // dangerouslySetInnerHTML, чтобы контент отобразился сразу.
  return (
    <div
      ref={containerRef}
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
})

MemoizedHTML.displayName = 'MemoizedHTML'

export default MemoizedHTML
